import * as React from "react";
import { Box, Stack, TextField, TextFieldProps, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { GridColDef, GridRowsProp } from "@mui/x-data-grid-premium";
import CclGenericAccordian from "../../../../../components/common/cclGenericAccordian";
import CclLoadingButton from "../../../../../components/common/cclButtons/cclLoadingButton";
import ReportsDataGridDataGridPanel from "./reportDataGrid";

export interface PayrollReviewProps {
    sessionId: string;
}

const PayrollReview: React.FC<PayrollReviewProps> = (props) => {
    const sessionId = props.sessionId;
    const [payPeriodEndDate, setPayPeriodEndDate] = React.useState<Date | null>(null);
    const [showData, setShowData] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const timeout = (delay: number) => new Promise(res => setTimeout(res, delay));

    const generateReport = async () => {
        setShowData(false);
        setLoading(true);
        await timeout(500);
        setShowData(true);
        setLoading(false);
    }

    const onDateChange = (date: Date | null) => {
        setPayPeriodEndDate(date);
    }

    const searchInputSx = {
        "& .MuiOutlinedInput-input": {
            paddingTop: "8px!important",
            paddingBottom: "8px!important",
        },
        "& .MuiInputLabel-root": {
            marginTop: "-8px!important",
        },
        "& .MuiInputLabel-shrink": {
            marginTop: "auto!important",
        },
        width: .25
    };

    const columns: GridColDef[] = [
        { field: "revRecDate", headerName: "RevRecDate", width: 150 },
        { field: "glLetters", headerName: "GLLetters", width: 150 },
        { field: "groupNumber", headerName: "GroupNumber", width: 150 },
        { field: "realHours", headerName: "RealHours", width: 150 },
        { field: "adjunctName", headerName: "Adjunct Name", width: 150 },
        { field: "employeeId", headerName: "Employee ID", width: 150 },
        { field: "chargeDate", headerName: "Charge Date", width: 150 },
        { field: "earningsCode", headerName: "EarningsCode", width: 150 },
        { field: "hours", headerName: "# Hours", width: 150 },
        { field: "amount", headerName: "Amount", width: 150 },
        { field: "pieceCode", headerName: "Piece Code", width: 150 },
        { field: "shiftCode", headerName: "ShiftCode", width: 150 },
        { field: "location", headerName: "Location", width: 150 },
        { field: "jobCode", headerName: "Job Code", width: 150 },
        { field: "eventCode", headerName: "EventCode", width: 150 },
        { field: "org1BusinessUnit", headerName: "Org1 Buisness Unit", width: 180 },
        { field: "org2Group", headerName: "Org2 Group", width: 150 },
        { field: "org3Dept", headerName: "Org3 Dept", width: 150 },
        { field: "org4GLLoc", headerName: "Org4 GLLoc", width: 150 },
    ];

    const data: GridRowsProp = [];

    return (
        <Box sx={{ width: "100%" }}>
            <CclGenericAccordian
                headingText={"Payroll Review Report"}
                defaultExpanded
            >
                <Stack sx={{margin: 1, padding: 1 }} spacing={2}>
                    <Stack direction={"row"} spacing={5} sx={{ mx: 2, mt: 2 }}>
                        <Typography sx={{ alignSelf: "center"}} variant="h6">Pay Period End Date</Typography>
                        <DatePicker
                            onChange={onDateChange}
                            value={payPeriodEndDate}
                            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => {
                                params.fullWidth = false;
                                return (
                                    <TextField
                                        {...params}
                                        sx={searchInputSx}
                                    />
                                );
                            }}
                        />
                        <CclLoadingButton
                            mode={"primary"}
                            sx={{marginLeft: "auto"}}
                            onClick={generateReport}
                            loading={loading}
                        >
                            Generate
                        </CclLoadingButton>
                    </Stack>
                    {showData && (
                        <ReportsDataGridDataGridPanel
                            sessionId={sessionId}
                            columns={columns}
                            data={data}
                        />
                    )}
                </Stack>
            </CclGenericAccordian>
        </Box>
    );
};

export default PayrollReview;
